// extracted by mini-css-extract-plugin
export default {"root":"_1ivpb","heading-and-subheading-block":"_1h76S","headingAndSubheadingBlock":"_1h76S","subheading":"_2FNUu"};